import { render, staticRenderFns } from "./MulBase.vue?vue&type=template&id=0b5728ae&scoped=true&"
import script from "./MulBase.vue?vue&type=script&lang=js&"
export * from "./MulBase.vue?vue&type=script&lang=js&"
import style0 from "./MulBase.vue?vue&type=style&index=0&id=0b5728ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5728ae",
  null
  
)

export default component.exports